import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AngalammanLanding from "./pages/AngalammanLanding";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ContactUs from "./pages/ContactUs";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Tanglish route for the landing page */}
          <Route 
            path="/melmalaiyanoor-Angalamman" 
            element={<AngalammanLanding />} 
          />
          {/* Legal and Contact Pages */}
          <Route 
            path="/Privacy Policy" 
            element={<PrivacyPolicy />} 
          />
          <Route 
            path="/Terms and conditions" 
            element={<TermsAndConditions />} 
          />
          <Route 
            path="/Contact Us" 
            element={<ContactUs />} 
          />
          {/* English alternative route */}
          <Route 
            path="/angalamman" 
            element={<AngalammanLanding />} 
          />
          {/* Redirect root to Tanglish route */}
          <Route 
            path="/" 
            element={<Navigate to="/melmalaiyanoor-Angalamman" replace />} 
          />
          {/* Catch all - redirect to main page */}
          <Route 
            path="*" 
            element={<Navigate to="/melmalaiyanoor-Angalamman" replace />} 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
